function ThemeButton(props) {
  return (
    <li className="animate fade">
      <a ctype="button" 
      onClick={() => props.onClickHandler(props.id)} className={`${props.selected ? "selected" : ""}`} 
      >
       <img src={`images/${props.image}.png`} />
      </a>
    </li>
  );
}

export default ThemeButton;
